<rt-group variant="horizontal" layout-justify-flex-end>
  <rt-follow-button
    [type]="'offer'"
    [followed]="offer.followed"
    [loading]="followLoading"
    [kind]="offer.kind"
    (followClick)="toggleFollow.emit(offer)"
    (unfollowClick)="toggleFollow.emit(offer)"
  >
  </rt-follow-button>

  @if (hasEdit) {
    <rt-icon-button variant="plain" iconName="edit" (click)="editOffer()" margin-lr-small-xx>
    </rt-icon-button>
  }
  @if (canManageJobs || canPromoteSection) {
    <rt-actions-dropdown-container [offer]="offer" type="table"> </rt-actions-dropdown-container>
  }
</rt-group>
